// @ts-nocheck
import { Column } from 'react-table'
// import { Link } from 'react-router-dom'
import { BlockUserCustomHeader } from './BlockCustomHeader'
// import { BlockUserActionsCell } from './BlockActionsCell'
import { useQueryResponsePagination } from '../../core/QueryResponseProvider'
import { BlockUser } from '../../core/_models'
import dayjs from 'dayjs'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { useQueryClient } from '@tanstack/react-query'
import { unblockUser } from '../../../_requests'

const blockUsersColumns: ReadonlyArray<Column<BlockUser>> = [
  {
    Header: (props) => <BlockUserCustomHeader tableProps={props} title='Sr No.' />,
    id: 'sr_no',
    Cell: ({ row }) => {
      const pagination = useQueryResponsePagination()
      const page = pagination?.page || 1
      const per = pagination?.items_per_page || 15
      const sr = (page - 1) * per + row.index + 1
      return <div>{sr}</div>
    },
  },
  {
    Header: (props) => <BlockUserCustomHeader tableProps={props} title='Blocker User' />,
    accessor: 'blocker_name',
    Cell: ({ value, row }) => (
      value
    ),
  },
  {
    Header: (props) => <BlockUserCustomHeader tableProps={props} title='Blocked User' />,
    accessor: 'blocked_name',
    Cell: ({ value, row }) => (
      value
    ),
  },
  {
    Header: (props) => <BlockUserCustomHeader tableProps={props} title='Reason' />,
    accessor: 'reason',
    Cell: ({ value, row }) => (
      value
    ),
  },
  {
    Header: (props) => <BlockUserCustomHeader tableProps={props} title='Date' />,
    accessor: 'blocked_at',
    Cell: ({ value }) =>
      value ? dayjs(value).format('DD MMM YYYY, hh:mm A') : '-',
  },
  {
    Header: (props) => <BlockUserCustomHeader tableProps={props} title='Unblock User' />,
    id: 'unblock',
    Cell: ({ row }) => {
      const queryClient = useQueryClient()
      const [loading, setLoading] = useState(false)

      const handleUnblock = async () => {
        try {
          setLoading(true)
          await unblockUser(row.original.id)
          toast.success('User unblocked successfully.')
          queryClient.invalidateQueries({ queryKey: ['block-user-list'] })
        } catch (err: any) {
          const msg = err?.response?.data?.message || err?.message || 'Failed to unblock user'
          toast.error(msg)
        } finally {
          setLoading(false)
        }
      }

      return (
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            id={`unblock-switch-${row.original.id}`}
            checked={false} // Since these are blocked users, switch is off
            onChange={handleUnblock}
            disabled={loading}
          />
          <label
            className="form-check-label"
            htmlFor={`unblock-switch-${row.original.id}`}
          >
            {loading ? 'Unblocking...' : 'Blocked'}
          </label>
        </div>
      )
    },
  }
]

export { blockUsersColumns }
